import { addTranslation } from '../../_helpers/Translate';

addTranslation({
  ru: {
    menuPage_startDate: 'Дата начала выдачи меню',
    menuPage_ageGroup:"Возрастная группа",
    menuPage_addButton:'Добавить меню',
    menu_breakfast:'Завтрак',
    menu_secondBreakfast:'Второй завтрак',
    menu_lunch:'Обед',
    menu_snack:'Полдник',
    menu_dinner:'Ужин',
    menu_lateDinner:'Поздний ужин',
    menuPage_startDateColumns:'Дата начала выдачи меню',
    menuPage_endDateColumns:'Дата окончания выдачи меню',
    menuPage_addMenuTitle:'Добавить меню',
    menuPage_editMenuTitle:'Изменить меню',
    menuPage_startDateOutputMenu:'Дата начала выдачи меню',
    menuPage_endDateOutputMenu:'Дата окончания выдачи меню',
    menuPage_ageGroups:'Возрастные группы',
    menuPage_chooseAgeGroups:'Выберите возрастные группы',
    menuPage_addToMenu:'Добавить в меню',
    menuPage_fillingTheMenu:'Заполнение меню',
    menuPage_selectFromRecent:"Выбрать из прошлых",
    menuPage_dish:'Блюдо',
    menuPage_addDish:'Добавить блюдо',
    menuPage_reviewMenu:'Предпросмотр меню',
    menuPage_close:'Закрыть',
    menuPage_save:'Сохранить',
    menuPage_delete:'Удалить',
    menuPage_recentMenus:'Прошедшие меню',
    menuPage_actions: 'Действия',
    menuPage_edit:'Редактировать меню',
    menuPage_addMenu:'Добавить меню',
    menuPage_successAdd: "Меню успешно добавлено",
    menuPage_successEdit: "Меню успешно обновлено",
    menuPage_day:"День",
    menuAdd_errorAddAgeGroup:"Добавление меню невозможно, т.к. на указанный период и возрастную группу уже есть меню",
    menuPage_errorExpiredDate:'Добавление меню невозможно, т.к. выдача меню по указанной дате окончена',
    menuPage_errorOverlapsMenu:'Добавление меню невозможно, т.к. на указанный период и возрастную группу уже есть меню',
    menuPage_errorActiveMenu:'Изменить дату и/или возрастную группу невозможно, т.к. выдача меню уже началась.',
    menuPage_errorLoadOrganizations:'Не удалось загрузить организацию',
    menuPage_errorLoadMenu:'Не удалось загрузить меню',
    menuPage_errorAddMenu:"Не удалось добавить меню",
    menuPage_errorEditMenu:"Не удалось редактировать меню",
    menuPage_errorLoadRecentMenu:'Не удалось загрузить прошедшие меню'
  },
  kk: {
    menuPage_startDate: 'Мәзірді беру басталған күн',
    menuPage_ageGroup: 'Жас тобы',
    menuPage_addButton: 'Мәзір қосу',
    menu_breakfast: 'Таңғы ас',
    menu_secondBreakfast: 'Екінші таңғы ас',
    menu_lunch: 'Түскі ас',
    menu_snack: 'Түскі жеңіл тағам',
    menu_dinner: 'Кешкі ас',
    menu_lateDinner: 'Кешкі кеш ас',
    menuPage_startDateColumns: 'Мәзірді беру басталған күн',
    menuPage_endDateColumns: 'Мәзірді беру аяқталған күн',
    menuPage_addMenuTitle: 'Мәзір қосу',
    menuPage_editMenuTitle: 'Мәзірді өзгерту',
    menuPage_startDateOutputMenu: 'Мәзірді беру басталған күн',
    menuPage_endDateOutputMenu: 'Мәзірді беру аяқталған күн',
    menuPage_ageGroups: 'Жас топтары',
    menuPage_chooseAgeGroups: 'Жас топтарын таңдаңыз',
    menuPage_addToMenu: 'Мәзірге қосу',
    menuPage_fillingTheMenu: 'Мәзірді толтыру',
    menuPage_selectFromRecent: 'Өткен мәзірлерден таңдау',
    menuPage_dish: 'Тағам',
    menuPage_addDish: 'Тағам қосу',
    menuPage_reviewMenu: 'Мәзірді алдын ала қарау',
    menuPage_close: 'Жабу',
    menuPage_save: 'Сақтау',
    menuPage_delete: 'Өшіру',
    menuPage_recentMenus: 'Өткен мәзірлер',
    menuPage_actions: 'Әрекеттер',
    menuPage_edit:'Мәзірді өзгерту',
    menuPage_addMenu:'Мәзірді қосу',
    menuPage_day:"Күн",
    menuAdd_errorAddAgeGroup:'Көрсетілген кезең мен жас тобына арналған мәзір бар болғандықтан, жаңа мәзірді қосу мүмкін емес.',
    menuPage_errorExpiredDate:'Көрсетілген күн бойынша мәзірді беру аяқталғандықтан, мәзірді қосу мүмкін емес.',
    menuPage_errorOverlapsMenu:"Көрсетілген кезең мен жас тобына арналған мәзір бар болғандықтан, жаңа мәзірді қосу мүмкін емес.",
    menuPage_errorActiveMenu:'Мәзірді беру басталып кеткендіктен, күнді және/немесе жас тобын өзгерту мүмкін емес.',
    menuPage_errorLoadOrganizations: 'Ұйымдарды жүктеу мүмкін болмады',
    menuPage_errorLoadMenu: 'Мәзірді жүктеу мүмкін болмады',
    menuPage_errorAddMenu: 'Мәзірді қосу мүмкін болмады',
    menuPage_errorEditMenu: 'Мәзірді өңдеу мүмкін болмады',
    menuPage_errorLoadRecentMenu: 'Өткен мәзірлерді жүктеу мүмкін болмады'
  }
});
